import { useAuth } from '@/lib/auth'

/** Verifica se um módulo está ativo no plano da empresa atual.
 * Default = true (módulo ativo) quando não está explicitamente desabilitado.
 *
 * Uso:
 *   const marketplaceAtivo = useModulo('marketplace')
 *   if (marketplaceAtivo) <ColunaPedidoML />
 */
export function useModulo(modulo: string): boolean {
  const { empresa } = useAuth()
  const m = (empresa?.modulos_ativos as Record<string, boolean> | null | undefined) || {}
  return m[modulo] !== false
}

/** Atalho específico — esconde coisas de ML/MP/Tray quando empresa não usa marketplace. */
export function useMarketplaceAtivo(): boolean {
  return useModulo('marketplace')
}
